import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { rehydrateDateAfterJsonization as w } from "../util/date-utils.js";

var ei = /*#__PURE__*/function () {
  function ei(t, i, l, s, u) {
    _classCallCheck(this, ei);

    this.endpoint = t || null, this.wn = i || null, this.publicKey = l || null, this.zl = s || null, this.gl = u || null;
  }

  _createClass(ei, [{
    key: "ss",
    value: function ss() {
      return {
        e: this.endpoint,
        c: this.wn,
        p: this.publicKey,
        u: this.zl,
        v: this.gl
      };
    }
  }], [{
    key: "yn",
    value: function yn(t) {
      return new ei(t.e, w(t.c), t.p, t.u, t.v);
    }
  }]);

  return ei;
}();

export { ei as default };